import 'view/css/messages.css'

import React, { useState, useEffect } from 'react'

import API from 'service/api'
import PopMessage from 'component/pop-msg/PopMessage'

import MessageConversationList from 'view/op/messages/MessageConversationList'
import MessageContent from 'view/op/messages/MessageContent'

import InstantMessageController from 'controller/InstantMessageController'

const MessageView = () =>
{
  const [wsState, setWsState] = useState('')
  const [refresher, setRefreshTimestamp] = useState(0)
  
  const [selectedConversation, setSelectedConversation] = useState()

  const onConnected = () =>
  {
    setWsState(InstantMessageController.WsConnectionState)
  }
  const onDisconnected = () =>
  {
    setWsState(InstantMessageController.WsConnectionState)
  }
  const onStatusChanged = () =>
  {
    setWsState(InstantMessageController.WsConnectionState)
  }
  const onMessageReceived = () =>
  {
    setRefreshTimestamp(new Date().valueOf())
  }

  const onConversationSelected = (conversation) =>
  {
    setSelectedConversation(conversation)

    if (!conversation.isAllMessagesLoaded)
    {
      // prevent white screen
      if (!conversation.details?.wa_id) {
        return
      }

      // the max sequence number to be retrieved is the min number in the list
      const maxseq = Math.min(...conversation.messages.map(m => m.seq))
      API.getMessages(conversation.details.wa_id, maxseq).then(resp =>
      {
        if (resp.success)
        {
          const messages = resp.msg.messages
          // stop reloading if there is no more messages
          if (messages.length == 0)
          {
            conversation.isAllMessagesLoaded = true
            return
          }

          for (var msg of messages)
          {
            conversation.messages.push(msg)
          }

          // call re-render
          setRefreshTimestamp(new Date().valueOf())
        } else {
          PopMessage.show('讀取訊息時發生錯誤。', '錯誤', 'danger')
        }
      })
    }
  }

  useEffect(() =>
  {
    InstantMessageController.register(
      setRefreshTimestamp,
      {
        onConnected,
        onDisconnected,
        onStatusChanged,
        onMessageReceived
      }
    )
    InstantMessageController.initialize()
  }, [])

  return (
    <div className="whatsapp-message-view">
      <MessageConversationList {...{refresher, wsState}}
        onConversationSelected={onConversationSelected} />
      <MessageContent {...{refresher, selectedConversation}} />
    </div>
  )
}

export default MessageView
